import { HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import moment from "moment";

@Injectable({
    providedIn: 'root'
})
export abstract class BaseService {

    constructor() {
    }

    protected getHeader(loader: boolean) {
        let headers = new HttpHeaders();
        if (loader) {
            headers = headers.set('loader', 'true');
        }
        return headers;
    }

    protected parseParams(params: any): any {
        let httpParams = new HttpParams();
        let obj = Object.keys(params)
            .filter(key => {
                const dataParam = params[key];
                return Array.isArray(dataParam) || typeof dataParam === 'string'
                    ? dataParam.length > 0
                    : dataParam !== null && dataParam !== undefined;
            });
        obj.forEach(key => {
            if (params[key] instanceof Date) {
                httpParams = httpParams.set(key, moment(params[key]).format('MM/DD/YYYY'));
            } else {
                httpParams = httpParams.set(key, params[key]);
            }
        });
        return httpParams;
    }

    protected parseParamsList(params: any): any {
        let httpParams = new HttpParams();
        params.forEach((x: any) => {
            const name = Object.getOwnPropertyNames(x)[0];
            httpParams = httpParams.append(name, Object(x)[name]);
        });
        return httpParams;
    }
}